/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Typ iets ...',
  'fabric.editor.editorAssistiveLabel': 'Hoofdveld content, begin met typen om tekst in te voeren.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Open helpdialoogvenster',
};
